import MessageCollection from '@/validator/MessageCollection';

import Validator from './Validator';

export default {
  computed: {
    errors: {
      get() {
        return this.$validator.messageBag.errors || new MessageCollection();
      },
    },
    warnings: {
      get() {
        return this.$validator.messageBag.warnings || new MessageCollection();
      },
    },
    successMessages: {
      get() {
        return this.$validator.messageBag.success || new MessageCollection();
      },
    },
    messageBag: {
      get() {
        return this.$validator.messageBag || new MessageCollection();
      },
    },
  },
  beforeCreate() {
    this.$validator = new Validator(this);
    // app.util.defineReactive(this.$validator, 'messageBag', this.$validator.messageBag);
    // app.util.defineReactive(this.$validator, 'errors', this.$validator.messageBag.errors);
    // app.util.defineReactive(this.$validator, 'warnings', this.$validator.messageBag.warnings);
    // app.util.defineReactive(this.$validator, 'successMessages', this.$validator.messageBag.success);
  },
  mounted() {
    // this.$validator.init(new LineItem()); // TODO: Move this to each Edit<ModelName>.vue
  },
};
